module.exports = __webpack_public_path__ + "img/email.3660a2e8.svg";